"use strict";

import React from 'react';
import OrderAdjustment from "./OrderAdjustment";

const OrderAdjustments = ({
    adjustments=[],
    title='Adjustments',
    type="credit",
    colSpan=0,
}) => {

    if(!!adjustments && adjustments.length)
    {
        return(
            <tbody className="table__body__adjustments">
                <tr className="" style={{borderBottom: '1px solid #dddddd',background: 'whitesmoke',}}>
                    <td colSpan={colSpan} style={{padding: '.3rem .3rem .3rem 1rem',}}>
                        <p className="is-marginless"
                            style={{display: 'inline-block',marginRight: '1rem'}}>
                            {title}
                        </p>
                        <span className="label__light-gray label--round">{adjustments.length}</span>
                    </td>
                </tr>
                {adjustments.map((adjustment) =>
                    <OrderAdjustment key={adjustment.id}
                                     adjustment={adjustment}
                                     type={type} />
                )}
            </tbody>
        );
    }
    return null;

};

export default OrderAdjustments;